<template>
<div class="chapter">
<div class="inner_page">
<div id="epub4231.html" xml:lang="en-GB">
<div class="Basic-Text-Frame">
<p class="CN" id="toc_marker-1"><img alt="DyingHoursFRONTCOVER.jpg" class="image" height="599" src="images/DyingHoursFRONTCOVER_fmt.jpeg" width="397"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epub4231.vue?b2697220